.fa.small {
  font-size: 80%;
}